import script from "./BasePdfStyle.vue?vue&type=script&setup=true&lang=ts"
export * from "./BasePdfStyle.vue?vue&type=script&setup=true&lang=ts"

import "./BasePdfStyle.vue?vue&type=style&index=0&id=6ab5757a&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ab5757a"]])

export default __exports__